import { EmptyDashboardComponent } from "./EmptyDashboardComponent";
import { ShoppingCart } from "lucide-react";

export function ShoppingListComponent({ shoppingListItemsToGet, onClick }) {
  return (
    <div
      className="lg:col-span-2 bg-white rounded-xl border border-gray-200 p-6 shadow-sm w-full"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        Shopping List
      </h2>

      {shoppingListItemsToGet.length === 0 ? (
        <EmptyDashboardComponent icon={ShoppingCart} />
      ) : (
        <div
          className="overflow-y-auto space-y-1 w-full"
          style={{ maxHeight: "400px" }}
        >
          {shoppingListItemsToGet.map((item, index) => (
            <div
              key={index}
              className="group flex items-center justify-between px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors w-full"
            >
              {/* Left: Item name */}
              <span className="text-sm text-gray-900 font-medium">
                {item.itemName}
              </span>

              {/* Right: Quantity */}
              <span className="text-xs text-gray-500 whitespace-nowrap ml-4">
                {item.itemQuantity} {item.itemUnit}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
